import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';
import * as icons from '../icons/Icons';
export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="site-footer">
      <div className="container footer-content">
        <button className="footer-logo nav-btn-reset" onClick={() => navigate('/')}>
          <img src={icons.logo} alt='logo' width="80px" />
        </button>
        <p className="footer-copy">
          &copy; {new Date().getFullYear()} Jaylano van der Veen
        </p>
        <div className="footer-links">
          <a href="mailto:jaylanovanderveen.work@gmail.com" className="footer-link">Email</a>
          <a href="https://instagram.com/Jaylanooooo" target="_blank" rel="noreferrer" className="footer-link">Instagram</a>
        </div>
      </div>
    </footer>
  );
}
